import { SaveType } from '@tencent/mega-sdk-protocols';
import { DataConvertError } from './local-edit-data-converter.interface';

export enum ConvertStage {
    Load = 'load',
    Save = 'save',
}

export type IConvertErrorModalOptions<Stage extends ConvertStage> = {
    error: DataConvertError;
    stage: Stage;
    retry?: Stage extends ConvertStage.Load ? () => Promise<void> : (saveType?: SaveType) => Promise<void>;
};

export interface IConvertErrorModal {
    show<Stage extends ConvertStage>(options: IConvertErrorModalOptions<Stage>): void;
}
